import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_StudentGuidance } from "../shared/data.service";
import { GuidanceInsertRequest } from "../shared/GuidanceInsertRequest";
import * as moment from "moment";

@Component({
	selector: "app-student-add-log",
	templateUrl: "./student-add-log.component.html",
	styleUrls: ["./student-add-log.component.css"],
})
export class StudentAddLogComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentGuidanceService: DataService_StudentGuidance
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;

		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;
	}

	//////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////

	user: any;
	SelectedPerson: any;

	StudentID: any = "";
	StudentName: any = "";
	LogDate: Date = new Date();
	LogTime: Date = new Date();
	Comments: any = "";

	errorMessage: any = "";

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////
	onAdd() {
		var fDate = moment(new Date(this.LogDate)).format("MM/DD/YYYY") + " " + moment(new Date(this.LogTime)).format("HH:mm:00");

		if (String(fDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Date";
			return;
		}

		if (String(this.Comments).length > 1000) {
			this.errorMessage = "Comments cannot be longer than 1000 characters";
			return;
		}

		let parms: GuidanceInsertRequest = {
			Advisor_PersonID: this.user.personID,
			PersonID: this.SelectedPerson.PersonID,
			GuidanceDT: fDate,
			Comments: this.Comments,
		};

		var result = this.StudentGuidanceService.GuidanceInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Guidance Log was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Guidance Log",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////////
}
